package com.hyperether.goodjob.database

import app.cash.sqldelight.async.coroutines.awaitAsList
import app.cash.sqldelight.async.coroutines.awaitAsOneOrNull
import app.cash.sqldelight.coroutines.asFlow
import app.cash.sqldelight.coroutines.mapToList
import com.hyperether.goodjob.repository.Mapper
import kotlinx.coroutines.Dispatchers
import kotlinx.coroutines.flow.Flow

class ContactDaoImpl(private val sharedDatabase: SharedDatabase) : ContactDao {
    override suspend fun insertContact(contact: com.hyperether.goodjob.models.Contact) {
        sharedDatabase { database ->
            database.appDatabaseQueries.transaction {
                database.appDatabaseQueries.insertContact(
                    _id = contact.id,
                    name = contact.name,
                    address = Mapper().objectAsJson(contact.addressObject),
                    phone = contact.phone,
                    contactType = contact.contactType,
                    industry = contact.industry,
                    email = contact.email,
                    personAddress = contact.personAddress,
                    personName = contact.personName,
                    personEmail = contact.personEmail,
                    personPhone = contact.personPhone,
                    workspaceId = contact.workspaceId
                )
            }
        }
    }

    override suspend fun getContactsFlow(): Flow<List<Contact>> {
        return sharedDatabase { database ->
            database.appDatabaseQueries
                .getContacts()
                .asFlow()
                .mapToList(Dispatchers.Default)
        }
    }

    override suspend fun getContacts(): List<Contact> =
        sharedDatabase { database ->
            database.appDatabaseQueries
                .getContacts()
                .awaitAsList()
        }

    override suspend fun updateContactById(contact: com.hyperether.goodjob.models.Contact) {
        sharedDatabase { database ->
            database.appDatabaseQueries.updateContactByID(
                id = contact.id,
                _id = contact.id,
                name = contact.name,
                contactType = contact.contactType,
                industry = contact.industry,
                address = Mapper().objectAsJson(contact.addressObject),
                email = contact.email,
                phone = contact.phone,
                personName = contact.personName,
                personEmail = contact.personEmail,
                personAddress = contact.personAddress,
                personPhone = contact.personPhone,
                workspaceId = contact.workspaceId
            )
        }
    }

    override suspend fun deleteContactById(id: String) {
        sharedDatabase { database ->
            database.appDatabaseQueries.deleteContactById(id)
        }
    }

    override suspend fun deleteAllContacts() {
        sharedDatabase { database ->
            database.appDatabaseQueries.deleteAllContacts()
        }
    }

    override suspend fun getContactById(id: String): Contact? {
        return sharedDatabase { database ->
            database.appDatabaseQueries
                .getContactById(id)
                .awaitAsOneOrNull()
        }
    }
}
